import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useRiskColumns(component = 'risks') {
	const i18n = useI18n()
	const cols = columnStore()

	const code = cols.define(component, 'code', i18n.t('risk.code'), true)
	const name = cols.define(component, 'name', i18n.t('risk.name'), true)
	const probability = cols.define(component, 'probability', i18n.t('risk.probability'), true)
	const impact = cols.define(component, 'impact', i18n.t('risk.impact'), true)
	const score = cols.define(component, 'score', i18n.t('risk.score.label'), true)
	const residual = cols.define(component, 'residual', i18n.t('risk.residual'), true)
	const responsible = cols.define(component, 'responsible', i18n.t('risk.responsible'), true)
	const residualScore = cols.define(component, 'residualScore', i18n.t('risk.residualRiskScore'), true)
	const cia = cols.define(component, 'cia', i18n.t('risk.cia'), true)
	const treatment = cols.define(component, 'treatment', i18n.t('risk.riskTreatment'), true)
	const dueDate = cols.define(component, 'due_date', i18n.t('risk.dueDate'), true)
	const comment = cols.define(component, 'comment', i18n.t('misc.comment'), true)
	const description = cols.define(component, 'description', i18n.t('risk.description'), true)
	const catalog = cols.define(component, 'catalog', i18n.t('risk.catalog'), true)
	const category = cols.define(component, 'category', i18n.t('risk.category'), true)
	const instance = cols.define(component, 'instance_id', i18n.t('instance'), true)
	const lastReview = cols.define(component, 'last_review', i18n.t('lastReview'), true)
	const acceptedResidualRisk = cols.define(component, 'accepted_residual_risk', i18n.t('risk.acceptable'), true)
	const mitigationMeasures = cols.define(component, 'mitigation_measures', i18n.t('risk.mitigationMeasure', 2), true)
	const connections = cols.define(component, 'connections', i18n.t('risk.connection', 2), true)

	const columns = {
		code,
		name,
		probability,
		impact,
		score,
		residual,
		responsible,
		residualScore,
		cia,
		treatment,
		dueDate,
		comment,
		description,
		category,
		catalog,
		instance,
		lastReview,
		acceptedResidualRisk,
		mitigationMeasures,
		connections,
	}

	const { custom, all } = cols.finalize(component, columns)

	return { columns, custom, all }
}
